package ui.components.organisms

import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*
import ui.components.molecules.AppHeader
import ui.components.atoms.FloatingActionButton
import presentation.state.AppState
import domain.model.*
import ui.theme.ThemeMode

@Composable
fun MainLayout(
    state: AppState,
    onThemeToggle: () -> Unit,
    onSettingsClick: () -> Unit,
    onAddActionClick: () -> Unit,
    content: @Composable () -> Unit
) {
    Div(
        attrs = {
            classes("app-container")
            style {
                minHeight(100.vh)
                backgroundColor(Color("var(--bg-primary)"))
                color(Color("var(--text-primary)"))
                position(Position.Relative)
            }
        }
    ) {
        AppHeader(
            isAuthenticated = state.isAuthenticated,
            onThemeToggle = onThemeToggle,
            onSettingsClick = onSettingsClick,
            onAddActionClick = onAddActionClick
        )
        
        Main(
            attrs = {
                style {
                    padding(16.px)
                    maxWidth(1200.px)
                    property("margin", "0 auto")
                }
            }
        ) {
            content()
        }
        
        // Theme toggle FAB
        FloatingActionButton(
            icon = when (state.currentTheme) {
                ThemeMode.LIGHT -> "☀️"
                ThemeMode.DARK -> "🌙"
                ThemeMode.AUTO -> "🔄"
            },
            onClick = onThemeToggle,
            color = "#8b5cf6"
        )
    }
}